<template>
  <div class="dam-wrapper">
    <v-menu
      offset-y
      left
      :close-on-content-click="true"
      content-class="dam-menu-content"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          small
          v-bind="attrs"
          v-on="on"
          class="dam-trigger-btn"
          title="تنظیمات"
        >
          <v-icon color="primary" size="20">mdi-cog</v-icon>
        </v-btn>
      </template>

      <div class="dam-list">
        <div
          v-for="action in menuActions"
          :key="action.key"
          class="dam-list-item"
          @click="handleAction(action)"
        >
          <span class="dam-item-icon" :style="{ color: action.color }">
            <v-icon :style="{ color: action.color }" size="18">{{ action.icon }}</v-icon>
          </span>
          <span class="dam-item-title">{{ action.title }}</span>
        </div>

        <div class="dam-divider"></div>

        <!-- Toggle Status Action -->
        <div
          class="dam-list-item dam-toggle-item"
          :class="device.disabled ? 'dam-enable-action' : 'dam-disable-action'"
          @click="toggleDeviceStatus"
        >
          <span class="dam-item-icon">
            <v-icon :color="device.disabled ? 'success' : 'error'" size="18">
              {{ device.disabled ? 'mdi-check-circle' : 'mdi-cancel' }}
            </v-icon>
          </span>
          <span class="dam-item-title">
            {{ device.disabled ? 'فعال کردن دستگاه' : 'غیرفعال کردن دستگاه' }}
          </span>
        </div>
      </div>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'DeviceActionsMenu',
  props: {
    device: {
      type: Object,
      required: true
    },
    actions: {
      type: Array,
      required: true
    }
  },
  computed: {
    menuActions() {
      return this.actions.map((action, index) => ({
        ...action,
        key: `action-${index}`
      }))
    }
  },
  methods: {
    handleAction(action) {
      if (action.handler) {
        action.handler(this.device)
      }
    },
    toggleDeviceStatus() {
      this.$emit('toggle-status', this.device)
    }
  }
}
</script>

<style>
/* Device Actions Menu - Unique prefix: dam- */
.dam-wrapper {
  display: inline-block;
}

.dam-trigger-btn {
  background-color: #f5f5f5 !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 4px !important;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
}

.dam-trigger-btn:hover {
  background-color: #e8e8e8 !important;
}

.dam-menu-content {
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  overflow: hidden;
  z-index: 9999 !important;
}

.dam-list {
  min-width: 200px;
  background: #fff;
  padding: 8px 0;
}

[dir=rtl] .dam-list {
  direction: rtl;
}

.dam-list-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  gap: 10px;
}

.dam-list-item:hover {
  background-color: #f5f5f5;
}

.dam-item-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  flex-shrink: 0;
}

.dam-item-title {
  font-size: 13px;
  color: #333;
  white-space: nowrap;
}

.dam-divider {
  height: 1px;
  background-color: #e0e0e0;
  margin: 8px 0;
}

.dam-toggle-item {
  margin-top: 4px;
}

.dam-enable-action {
  background-color: #e8f5e9 !important;
}

.dam-enable-action:hover {
  background-color: #c8e6c9 !important;
}

.dam-disable-action {
  background-color: #ffebee !important;
}

.dam-disable-action:hover {
  background-color: #ffcdd2 !important;
}
</style>